const selfSelector = (state) => state.domainsReport;

export default selfSelector;
